import { FieldValidation } from '../../core/domain/transaction/fieldValidation';
import { Regex } from '../../core/enums/regex';
import { pattern } from './pattern';

export const email: FieldValidation = pattern(Regex.Email);
